import { useEffect, useState } from "react";
import { CalendarCheck, Home, Star, Euro } from "lucide-react";
import api from "../../lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState({ bookings: 0, apartments: 0, reviews: 0, revenue: 0 });

  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  const cards = [
    { label: "Prenotazioni confermate", value: stats.bookings, icon: CalendarCheck },
    { label: "Ricavi totali", value: `€${stats.revenue}`, icon: Euro },
    { label: "Appartamenti", value: stats.apartments, icon: Home },
    { label: "Recensioni", value: stats.reviews, icon: Star },
  ];

  return (
    <div>
      <h1 className="font-display text-4xl text-fir mb-2">Dashboard</h1>
      <p className="text-fir-deep/60 mb-8">Panoramica della tua struttura a Dimaro</p>
      <div className="grid md:grid-cols-4 gap-5">
        {cards.map((c) => (
          <div key={c.label} data-testid="stat-card" className="bg-white rounded-2xl p-6 border border-stone shadow-sm">
            <c.icon className="text-gold mb-3" size={26} />
            <p className="font-display text-3xl text-fir">{c.value}</p>
            <p className="text-sm text-fir-deep/60 mt-1">{c.label}</p>
          </div>
        ))}
      </div>
      <div className="mt-10 bg-white rounded-2xl p-8 border border-stone">
        <h2 className="font-display text-2xl text-fir mb-3">Benvenuto nel pannello</h2>
        <p className="text-fir-deep/70 leading-relaxed">
          Da qui gestisci appartamenti, il motore di <b>Dynamic Pricing IA</b>, le prenotazioni e le integrazioni
          con <b>Smoobu</b> e <b>PayPal</b>. Inizia collegando i tuoi account nella sezione <b>Integrazioni</b>.
        </p>
      </div>
    </div>
  );
}
